export default __webpack_public_path__ + "static/media/loader.d3fbaf2b.gif";